module.exports = __webpack_public_path__ + "static/media/21meta.fa3712b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/21meta.mp4
// module id = 725
// module chunks = 1